import { Outlet } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import Nav from "./Nav";
import Footer from "./Footer";
import { BRAND } from "../data/content";

const ORG_JSONLD = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "Advanced Connected Technologies",
    alternateName: "ACT",
    description:
        "Luxury smart home integration studio for principal residences. Concierge-tier design, certified delivery, and lifetime stewardship.",
    url: "https://actluxe.net/",
    logo: "https://actluxe.net/favicon.svg",
    sameAs: [],
    contactPoint: [
        {
            "@type": "ContactPoint",
            telephone: BRAND.phoneSchema,
            email: BRAND.email,
            contactType: "Concierge",
            areaServed: "Worldwide",
            availableLanguage: ["English"],
        },
    ],
};

/**
 * Shared shell — sticky nav + page outlet + footer.
 * Also injects the Organization JSON-LD on every page.
 */
export default function Layout() {
    return (
        <div className="min-h-screen flex flex-col bg-[#0B0B0C] text-[#F3EFE7]">
            <Helmet>
                <script type="application/ld+json">
                    {JSON.stringify(ORG_JSONLD)}
                </script>
            </Helmet>
            <Nav />
            <main className="flex-1 overflow-x-clip">
                <Outlet />
            </main>
            <Footer />
        </div>
    );
}
